import { type RefObject, useLayoutEffect, useState } from 'react';

export function useElementWidth(ref: RefObject<HTMLElement | null>): number {
  const [width, setWidth] = useState(() => ref.current?.offsetWidth ?? 0);

  // Assumes a stable observed element — if the element at ref.current is replaced, the observer stays on the old node.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    setWidth(el.offsetWidth);

    const observer = new ResizeObserver((entries) => {
      const newWidth = entries[0]?.contentRect.width ?? 0;
      setWidth(newWidth);
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return width;
}
